import React, {
	Component
} from 'react';
import { observer } from 'mobx-react';
import FieldSetting from './FieldSetting';
import FormSetting from './FormSetting';
import TemplateEdit from './TemplateEdit';

@observer
export default class AddressBookExportSetting extends Component {
	constructor(props) {
        super(props);
    }

	render() {
        return (
            <div>
                <FieldSetting store={this.props.store} />
                <TemplateEdit store={this.props.store} />
                <FormSetting store={this.props.store} />
            </div>
        )
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/resourceExportTemplate/AddressBookExportSetting.js